import React, { useState, useEffect } from "react";
import "styles/scss/topButton.scss";
const TopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);


  // 최상단으로 이동하는 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 부드럽게 이동
    });
  };

  return (
    <button
      className={`top-button ${isVisible ? "show" : ""}`}
      onClick={scrollToTop}
    >
      ↑ Top
    </button>
  );
};

export default TopButton;
